<template>
  <hitv-call-app :scheme-url="callPlayerUrl">
    <div class="home">
      <!-- 头部简介 -->
      <HeaderArea />
      <!-- 积分 现金信息总览 -->
      <InfoPreview />
      <!-- 签到模块 -->
      <div id="step2" v-if="!isNoneCashVer">
        <SignDaily 
          :sign-settings="activityInfo.signInTask" 
          :task-sign="activityInfo.signTaskSign" 
          :subscribeStatus="activityInfo.subscribeStatus"
          :userTaskStageSign="activityInfo.signUserTaskStageSign" 
          :userTaskStatus="activityInfo.signUserTaskStatus" 
        />
      </div>
      <!-- 现金任务 -->
      <div id="step1" v-if="!isNoneCashVer">
        <MoneyTask 
          :invite-settings="activityInfo.inviteTask" 
          :inviteTaskId="activityInfo.inviteTaskId" 
          :taskSign="activityInfo.inviteTaskSign" 
        />
        <div class="guide-3" ref="guide3" v-if="showGuide"></div>
      </div>
      <!-- 积分任务 -->
      <CreditsTask />

      <SecKill
        v-if="isKillingNow"
        @isKillingNow="isKillingNow = true"
        class="m-SecKill"
      />

      <Slide
        class="m-slider"
        :list="banners"
        :carousel="isCarousel"
        v-if="banners.length && devicesInfo && devicesInfo.prech != 'samsung'"
      />
      
      <SelectForYou
        class="m-selectforyou"
        :moduleList="moduleList"
        v-if="moduleList.length"
      />
      <ExchangeRank
        class="m-exchangerank"
        :moduleList="moduleList"
        v-if="moduleList.length"
      />
      <SecKill
        v-if="!isKillingNow"
        @isKillingNow="isKillingNow = true"
        class="m-SecKill"
      />

      <MgGoodThings
        class="m-space"
        v-for="(info, index) in goods"
        :key="index"
        :info="info"
      />

      <RightLayer
        :info="layerCreditsConf"
        v-if="isShowPopupAct && devicesInfo && devicesInfo.prech != 'samsung'"
        @close="isShowPopupAct = false"
      />

      <InviteResultDialog
        v-if="showResultInvite"
        :inviteResult="inviteResult"
        @close="closeInviteResult"
      />

      <Guide @finish="onGuideFinish" v-if="activityInfo.inviteTask" />
      <!-- 公告栏 -->
      <Dialog
        v-model="modalManager.state.visibleMap.a"
        title="公告栏"
        :confirmText="noticeInfo.button || '我知道了'"
        :show-footer="true"
        @close="handlePublicNoticeClose"
        @confirm="handlePublicNoticeConfirm"
        content-class="public-notice-content"
        :zIndex="2000"
      >
        <div>{{noticeInfo.content}}</div>
      </Dialog>
      
      <!-- 版本禁止助力弹窗 -->
    <Dialog
      v-model="modalManager.state.visibleMap.d"
      confirmText="我知道了"
      @confirm="() => { modalManager.close('d') }"
      @close="() => { modalManager.close('d') }"
      :append-to-body="true"
      content-class="disable-help-content"
    >
      <div class="version-update-content">
        <p class="txt">对不起，您的版本暂不支持助力，尽请期待</p>
      </div>
    </Dialog>
    </div>
  </hitv-call-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HOME_API } from '@/utils/fetch-set'
import { doShareSurpport } from '@/utils/service'
import {
  monitorPageVisibility,
  isInApp,
  setNewWXShareInfo,
} from '@/utils/mUtil'
import { setTimeout } from 'timers'
import SelectForYou from '@/v2-components/business/index/selectForYou.vue'
import ExchangeRank from '@/v2-components/business/index/exchangeRank'
import SecKill from '@/v2-components/business/index/secKill'
import MgGoodThings from '@/v2-components/business/index/mgGoodThings'
import Slide from '@/v2-components/business/index/slide'
import RightLayer from '@/v2-components/base/right-layer'
import InviteResultDialog from '@/v2-components/invite-result-dialog'
import HeaderArea from '@/v2-components/header-area'
import InfoPreview from '@/v2-components/info-preview'
import SignDaily from '@/v2-components/sign-daily'
import MoneyTask from '@/v2-components/money-task'
import Dialog from '@/v2-components/dialog'
import Guide from '@/v2-components/guide'
import CreditsTask from '@/v2-components/credits-task'
import { getNoticeBoard, getActivityList, eventJoin } from "@/request/cash.js";
import { EventBus } from '@/utils/eventBus';
import modalManager from '@/utils/modalManager';

export default {
  name: 'home',
  components: {
    SelectForYou,
    HeaderArea,
    InfoPreview,
    SignDaily,
    MoneyTask,
    MgGoodThings,
    ExchangeRank,
    SecKill,
    RightLayer,
    InviteResultDialog,
    Slide,
    Dialog,
    CreditsTask,
    Guide,
  },
  data() {
    return {
      noticeInfo: {
        content: '',
        button: "",
      },
      activityInfo: {
        signInTask: null,    // 签到任务信息（taskSettings数组）
        inviteTask: null,    // 邀请任务信息（taskSettings数组）
        activityEndTime: '', // 活动结束时间
        subscribeStatus: 0, // 提醒状态 0, 1
        inviteTaskId: 0,
        inviteTaskSign: '',
      },
      showPublicNotice: false, // 公告
      shareResultVisible: true,
      home: true,
      isKillingNow: false,
      layerCreditsConf: null,
      isShowPopupAct: false,
      banners: [],
      inviteResult: {},
      isCarousel: false,
      goods: [], // 芒果好物商品
      isHideTransition: false,
      moduleList: [], //好物商品模块列表
      isNewPoints: false,
      showResultInvite: false,
      showGuide: false,
      timer: null,
    }
  },
  created() {
    this.$store.dispatch('getNoticeAction')
    this.initData();
  },
  mounted() {
    this.setAppShare();
    this.setWxShare();

    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    if (isInApp()) {
      MgtvApi.setWebviewTitle({
        title: '每日开好礼',
      })
    } else {
      document.title = '每日开好礼'
    }

    this.isNewPoints = false
    this.setPageReshowCallBack()

    this.$nextTick(async () => {
      try {
        MgStat.send('pv',{},{ cntp: 'score_newHome',});
      } catch (error) {
        console.error('score_newHome pv 上报失败')
      }

      // 放在nextTick中请求，防止APP出现首次请求未发送的问题
      this.getActivityInfo();

      try {
        await this.getNoticeInfo();

        if (this.$route.query.inviteCode && this.isNoneCashVer) { // 限制邀请助力弹窗
          modalManager.add('d');
        }
      } catch (error) {
        if (this.$route.query.inviteCode && this.isNoneCashVer) { // 限制邀请助力弹窗
          modalManager.add('d');
        }
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    // 重设微信分享，修复IOS从二级页面返回时，分享被重置问题（IOS把一个webview当一个整体，如果二级页面设置了分享，会覆盖当前页面的分享）;
    handleVisibilityChange() {
      this.setAppShare();
      this.setWxShare();
    },
    // 顶部APP分享定义
    setAppShare() {
      const i = location.href.includes("?") ? '&' : '?'
      const title = '奖励中心领现金秒到账！'
      const desc = '每天开幸运盲盒，最高可得10元现金奖励！'
      const img = 'https://ossimg.hitv.com/platform_oss/0A666DA9702845268AD8C0FAF59ABB4A.png'
      MgtvApi.showShareMenus(
        {
          title,
          shareUrl: location.href,
          desc,
          shareIcon:img,
          customInfo: {
            // 朋友圈
            moments: {
              url:location.href + i + 'rch=p2to4roxe',
              title,
              desc,
              img
            },
            // 微信
            wechat: {
              url:location.href + i + 'rch=gkd9gtr2n',
              title,
              desc,
              img
            },
            // QQ
            qq: {
              url:location.href + i + 'rch=xv315d454',
              title,
              desc,
              img
            },
            // QQ 空间
            qzone: {
              url:location.href + i + 'rch=z6muretcy',
              title,
              desc,
              img
            },
            // 新浪微博
            weibo: {
              url:location.href + i + 'rch=glforc7d9',
              title,
              desc,
              img
            },
        }
        },
        (resp) => {
          if (resp.data.value == 1) {
            console.log('分享成功')
          }
        }
      )
    },
    // 微信内分享定义
    setWxShare() {
      const shareInfo = {
        title: '奖励中心领现金秒到账！',
        shareUrl: location.href,
        desc: '每天开幸运盲盒，最高可得10元现金奖励！',
        shareIcon:
          'https://ossimg.hitv.com/platform_oss/0A666DA9702845268AD8C0FAF59ABB4A.png',
      };
      setNewWXShareInfo(shareInfo);
    },

    // 确认公告栏
    handlePublicNoticeConfirm() {
      // this.showPublicNotice = false;
      modalManager.close('a');
    },

    // 关闭公告栏
    handlePublicNoticeClose() {
      // this.showPublicNotice = false;
      modalManager.close('a');
    },

    // 获取公告栏提示信息
    async getNoticeInfo() {
      try {
        const { code, data } = await getNoticeBoard()

        if (code === 200 && data.content) {
          this.noticeInfo = data;
          
          // 如果有新手引导，等待新手引导完成后再显示公告栏
          if (!localStorage.getItem('credits_guide') && this.isMGTV && !this.showGuide) {
            // 监听新手引导完成事件
            this.$once('guide-finish', () => {
              // this.showPublicNotice = true;
              modalManager.add('a');
            });
          } else {
            // 没有新手引导或新手引导已完成，直接显示公告栏
            // this.showPublicNotice = true;
            modalManager.add('a');
          }
        }
      } catch (error) {
        console.log('获取公告栏信息失败:', error)
      }
    },


    // 浏览性上报
    async eventJoinReport(joinTask) {
      eventJoin({
        taskSign: joinTask?.taskSign,
      });
    },
    // 获取签到任务和邀约任务信息
    async getActivityInfo() {
      try {
        const { data, code } = await getActivityList({
          listKey: 'CREDIT_LIST_KEYS'  // 拉取签到任务和邀约任务
        })

        if (code === 200) {
          const { TaskInfos, activityEndTime } = data
          
          // 处理任务信息，直接存储 taskSettings 数组
          const signInTask = TaskInfos.find(task => task.taskType === 1)
          const inviteTask = TaskInfos.find(task => task.taskType === 2)
          const joinTask = TaskInfos.find(task => task.listKey === 'credit_login')
          
          this.activityInfo = {
            activityEndTime,
            signInTask: signInTask?.taskSettings || [],  // 存储签到任务的 taskSettings
            inviteTask: inviteTask?.taskSettings || [],   // 存储邀请任务的 taskSettings
            signTaskSign: signInTask?.taskSign,
            subscribeStatus: signInTask?.subscribeStatus,
            inviteTaskId: inviteTask?.taskId,
            inviteTaskSign: inviteTask?.taskSign,
            signUserTaskStageSign: signInTask?.userTaskStageSign,
            signUserTaskStatus: signInTask?.userTaskStatus,
          }

          this.eventJoinReport(joinTask);
        }
      } catch (error) {
        this.$toast('网络错误，请刷新页面重试');
        console.log('获取活动信息失败:', error)
      }
    },

    onGuideFinish() {
      // 3 秒内点击其他区域 或 3秒后自动消失
      this.showGuide = true
      setTimeout(() => {
        document.addEventListener('click', this.clickOutside)
      }, 300)

      this.timer = setTimeout(() => {
        this.showGuide = false
        document.removeEventListener('click', this.clickOutside)
        // 触发新手引导完成事件
        this.$emit('guide-finish');
      }, 3000)
    },

    clickOutside(event) {
      if (!this.showGuide) return
      const isClickInsidePopup =
        this.$refs.guide3 && this.$refs.guide3.contains(event.target)
      if (!isClickInsidePopup) {
        this.showGuide = false
        clearTimeout(this.timer)
      }
    },

    initData() {
      this.getPointsModule()
      this._getLayerCreditsConf()
      this.checkUserLogin()
      this.getBannerList()
      this.doShareSurpport()
    },
    async getPointsModule() {
      try {
        const data = await HOME_API.getPointsModule(1)
        if (!Array.isArray(data || !data.length)) return
        this.moduleList = data
        this._getGoodByCatgory()
      } catch (error) {
        console.log(error)
      }
    },

    exitView() {
      MgtvApi.closeWebView()
    },

    closeInviteResult() {
      this.showResultInvite = false
      let queryStr = location.href.split('?')[1]
      if (queryStr) {
        queryStr = queryStr.replace('inviter', 'inv')
        history.replaceState({}, '', queryStr) //替换邀请的参数,避免刷新和返回的时候反复接受邀请
      }
    },
    async doShareSurpport() {
      if (!this.$route.query.inviter) {
        return
      }
      const inviteSelf = this.userInfo.uuid === this.$route.query.inviter
      if (!this.isLogin || inviteSelf) {
        return
      }
      try {
        const resData = await doShareSurpport(this.$route.query.inviter)
        this.inviteResult = { code: 200, ...resData }
        this.showResultInvite = true
      } catch (resError) {
        this.inviteResult = resError
        this.showResultInvite = true
      }
    },

    clickRuleHandle() {
      Report.click({
        value: '{"evt": "4010"}',
      })
      this.$router.push({ path: '/rule' })
    },

    // 获取右下角弹窗的信息
    async _getLayerCreditsConf() {
      try {
        const res = await HOME_API.getLayerCreditsConf()
        this.layerCreditsConf = res.layer[0]
        let nowTime = Math.ceil(new Date().getTime() / 1000)
        if (this.layerCreditsConf && nowTime <= this.layerCreditsConf.expire) {
          // $.get(this.layerCreditsConf.pv[0]); == 上报的逻辑  需确认
          this.isShowPopupAct = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 检查用户的登录状态
    checkUserLogin() {
      this.checkTime()

      this.$store.dispatch('queryCashUserInfo')
    },

    async checkTime() {
      try {
        const timestamp = parseInt(Date.now() / 1000)
        const res = await HOME_API.getVerifyTime(timestamp)
      } catch (error) {
        console.log(error)
      }
    },

    async getBannerList() {
      try {
        const data = await HOME_API.getBannerList(1)
        this.banners = data.banner.list
        this.isCarousel = data.banner.carousel == 1
      } catch (error) {
        console.log(error)
      }
    },

    async _getGoodByCatgory() {
      try {
        this.moduleList.forEach(async (item) => {
          if (item.type == 3) {
            const res = await this.getMgList({
              module_id: item.module_id,
              p: 1,
            })

            Array.isArray(res) &&
              res.length &&
              this.goods.push({
                name: item.module_name,
                list: res.slice(0, 6),
                id: item.module_id,
              })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getMgList(module_id) {
      try {
        const data = await HOME_API.getModuleGoodsList(module_id)
        return data.records
      } catch (error) {
        console.log(error)
      }
    },

    //设置页面重新显示的回调,包括其他webview回来/锁屏
    setPageReshowCallBack() {
      let ua = navigator.userAgent.toLowerCase()
      let _this = this
      if (/imgo/.test(ua)) {
        MgtvApi.registerhandler('webviewBecomeActive', {}, () => {
          //do something
          _this.initPage()
          // 发送页面重新显示的事件
          EventBus.$emit('page-reshow')
        })
      } else {
        monitorPageVisibility(() => {
          this.initPage()
          // 发送页面重新显示的事件
          EventBus.$emit('page-reshow')
        })
      }
    },
    initPage() {
      // 重新拉取签到邀约任务
      this.getActivityInfo();

      // 重新请求任务和积分的数据
      this.isNewPoints = true
      if (!this.isLogin) this.initInfo()

      setTimeout(() => {
        this.checkUserLogin()
      }, 300)
      this.$store.dispatch('getTaskInfo')

      if (this.bindPhone) {
        const userInfo = this._getServerUserInfo()
        if (userInfo) {
          MgtvApi.userCheckSucc({
            userinfo: JSON.stringify(userInfo),
          })
        }

        this.$store.commit('setBindPhone', false)
      }
    },
    async initInfo() {
      try {
        const USERINFO = await HOME_API.getUserInfo()
        const DEVICEINFO = await HOME_API.getDeviceInfo()
        window.USERINFO = USERINFO
        window.DEVICEINFO = DEVICEINFO
        this.$store.commit('setUserInfo', USERINFO)
        this.$store.commit('setDevicesInfo', DEVICEINFO)
        this.isNewPoints = false
      } catch (error) {
        console.log(error)
      }
    },
    async _getServerUserInfo() {
      try {
        const res = await HOME_API.getServerUserInfo()
        return res
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed: {
    modalManager() {
      return modalManager;
    },
    callPlayerUrl() {
      const url =
        location.href;
      return `imgotv://webview?url=${encodeURIComponent(url)}`
    },
    ...mapState([
      'taskInfo',
      'notices',
      'isMGTV',
      'userInfo',
      'devicesInfo',
      'points',
      'bindPhone',
      'isNoneCashVer',
    ]),
    ...mapGetters([
      'isLogin',
      'list',
      'canGetList',
      'notCanGetList',
      'isCreditEntryShow',
      'isCreditNavShow',
      'isCreditModalShow',
    ]),
  },
}
</script>

<style lang="less">
.public-notice-content {
  max-height: 511px;
  overflow-y: scroll;
  font-size: 28px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.6;
}

.version-update-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  margin-bottom: 24px;
  .txt {
    font-weight: 400;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.4);
    line-height: 40px;
    text-align: center;
  }
}

.home {
  padding: 0 36px;
  padding-bottom: 48px;
  background-color: #f5f5f5;

  .pb-20 {
    padding-bottom: 20px;
  }

  .m-bg-cover {
    .bgCover('./../../../assets/top-bg.png');
    padding-top: 80px;
    overflow: hidden;
    background-color: #fff;
    background-repeat: no-repeat;
    transition: height 0.5s ease;

    .rules {
      display: block;

      .wh(52px, 52px);
      .bgCover('../../../assets/help-icon.png');
      .abTr(30px, 30px);
    }

    .sign-point {
      display: block;
      font-size: 24px;

      .wh(52px, 52px);
      .bgCover('../../../assets/icon-sign.png');
      .abTr(30px, 112px);

      span {
        .abLt(50%, 50%);
        color: #fff;
        text-align: center;
        font-weight: bold;
        transform: scale(0.9) translate3d(-50%, -50%, 0);
        padding-right: 4px;
      }
    }
    // min-height: 390px;
  }

  .m-marquee {
    margin-top: 20px;
  }

  .m-taskinhome {
    margin: 30px 24px 0;

    .m-task-section {
      .m-title {
        margin-left: 6px;

        .to-task {
          margin: 0;
        }
      }

      .m-task-item:last-child {
        padding-bottom: 10px;
      }
    }
  }
  .student-only {
    margin: 30px 24px 0;
    > img {
      width: 100%;
    }

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-weight: bold;
      margin-left: 6px;
      margin-bottom: 28px;
      .sizeColor(34px, #000);
      .student-only-link {
        font-size: 24px;
        color: #999;

        &::after {
          content: '';
          display: inline-block;
          width: 13px;
          height: 13px;
          border: 3px solid #b3b3b3;
          border-radius: 4px;
          position: relative;
          margin-left: 3px;
          transform: rotateZ(-45deg);
          border-left-color: transparent;
          border-top-color: transparent;
        }
      }
    }
  }

  .m-selectforyou,
  .m-SecKill,
  .m-exchangerank,
  .m-nav,
  .m-space {
    margin-top: 24px;
  }

  .other-games {
    margin-top: 28px;
  }

  .m-slider {
    margin-top: 24px;
  }

  .header-bar {
    margin: 60px 0 50px;
  }

  .index-logo {
    .wh(400px, 200px);
  }
  #step1 {
    position: relative;
  }
  .guide-3 {
    position: absolute;
    .wh(300px, 126px);
    .bgCover('../../../assets/v2/guide/step3.png');
    top: 0;
    right: 0;
  }
}
</style>
